import elementResizeDetectorMaker from 'element-resize-detector';
import _ from 'lodash';
import moment from 'moment';
import tinycolor from 'tinycolor2';
import environment from '../../environment';
import { customScrollbar } from '../../shared';
import { converter } from '../converter';

import Container from './Container';
import KendoGrid from './KendoGrid';

class KendoChart extends Container {
    constructor (container, table, options) {
        super();
        this._export = this._export.bind(this);
        this._table = table;
        this.options = _.assign({}, this.options, options);

        this.dataTable = table.data;

        this.wrapper = this._createChartWrapper(options);
        this.wrapper.parent = container;
        $(container).html(this.wrapper.container);

        this._drawChart();
        this._detectScreenChanges(this.wrapper.container[0]);

        if (this.options.forceTable) {
            setTimeout(() => {
                $(this.wrapper.buttons.table).click();
            }, 100);
        }
    }

    _export (btn, name) {
        btn.on('click', () => {
            let filename;
            if (this.table) {
                const time = Number(moment(environment.get('CONFIG.FILTERS.ENDYEAR')).format('YYYY'));

                const $chartAreaName = $('#chart-area-name');

                if ($chartAreaName.text().length > 0) {
                    const title = $chartAreaName.text();
                    filename = `${title}_${time}_${name}`;
                } else {
                    filename = `${time}_${name}`;
                }
                const { table } = this.table;
                table.bind('excelExport', e => {
                    filename = String(this.options.filename)|| filename;
                    e.workbook.fileName = `${filename}.xlsx`;
                });
                return table.saveAsExcel();
            } else {
                return converter.csv({
                    name: String(this.options.filename || name),
                    type: 'charts',
                    data: this.dataTable.convertToTable()
                });
            }
        });
    }

    _detectScreenChanges (container) {
        let callback;
        let reloadChart = () => {
            clearTimeout(callback);
            callback = setTimeout(this._drawChart(), 200);
        };
        reloadChart = reloadChart.bind(this);

        if (container) {
            const erd = elementResizeDetectorMaker();
            erd.listenTo(container, reloadChart);
        } else {
            $(window).resize(reloadChart);
        }
    }

    _toggleLegend () {
        return this.wrapper.container.hasClass('chart-expanded-size');
    }

    _drawChart () {
        $(this.wrapper.chart).show();
        $(this.wrapper.table).hide();

        this.dataChart = this._convertTableChart(this._table, this.options.title);
        const content = $(this.wrapper.content);

        const options = {
            legend: _.assign({}, {
                visible: this._toggleLegend(),
                position: 'right',
                align: 'center',
                offsetX: 0
            }, this.dataChart.legend),
            seriesDefaults: this.dataChart.seriesDefaults,
            // seriesClick: () => this. window.open('http://localhost:4200/dnc/project/74/localeAgg/report/detail/1438/3', '_blank') ,
            seriesClick: this.options.seriesClick,
            chartArea: {
                width: this.options.width || content.width(),
                height: this.options.height || content.height(),
                margin: {
                    top: (this.options.margin || {}).top || 4,
                    bottom: (this.options.margin || {}).bottom || 4,
                    left: (this.options.margin || {}).left || 4,
                    right: (this.options.margin || {}).right || 4
                }
            },
            title: {
                text: null
            },
            transitions: false,
            categoryAxis: this.dataChart.categoryAxis,
            valueAxis: this.dataChart.valueAxis,
            theme: 'bootstrap',
            tooltip: this.options.tooltip !== 'none'
				? this.dataChart.tooltip
				: undefined,
            series: this.dataChart.series
        };

        this.chart = $(this.wrapper.chart).kendoChart(options);

        if (this.options.width > content.width()) {
            customScrollbar(this.wrapper.content, { axis: 'x' });
        } else if (this.options.height > content.height()) {
            customScrollbar(this.wrapper.content);
        }
    }

    _drawTable () {
        let options = {
            colors: true,
            inverse: true,
            extended: true
        };
        options = _.assign({}, options, this.options);
        this.table = new KendoGrid(this.wrapper, this.dataTable, options);
    }

    _getChartColor (color, colors) {
        if (!colors) {
            colors = [
                '#2196f3',
                '#00bcd4',
                '#4caf50',
                '#cddc39',
                '#ffc107',
                '#ff5722',
                '#e91e63',
                '#9c27b0',
                '#3f51b5',
                '#03a9f4',
                '#009688',
                '#8bc34a',
                '#ffeb3b',
                '#ff9800',
                '#f44336'
            ];
        }

        if (color + 1 > colors.length) {
            color = color + (1 % colors.length);
        }
        return colors[color];
    }

    _getLabelColor (color, colors) {
        if (!colors) {
            colors = [
                '#2196f3',
                '#00bcd4',
                '#4caf50',
                '#cddc39',
                '#ffc107',
                '#ff5722',
                '#e91e63',
                '#9c27b0',
                '#3f51b5',
                '#03a9f4',
                '#009688',
                '#8bc34a',
                '#ffeb3b',
                '#ff9800',
                '#f44336'
            ];
        }

        if (color + 1 > colors.length) {
            color = color + (1 % colors.length);
        }
        const c = tinycolor(colors[color]);
        while (c.isLight()) {
            c.darken(1);
        }
        return c.toHexString();
    }

    _convertTableChart (table, name) {
        const chart = {};
        chart.title = name;

        chart.legend = {
            labels: {
                font: '12px "Roboto Condensed", Helvetica, Arial, sans-serif',
                color: '#555555'
            }
        };

        if (table.legend) {
            chart.legend = table.legend;
        } else {
            if ((_.isBoolean(table.legend) && !table.legend) || (table.data || []).length === 2) {
                chart.legend = { visible: false };
            }
        }

        chart.seriesDefaults = {};

        chart.tooltip = {
            background: 'white',
            visible: true,
            shared: !table.singleTooltip
        };

        if (this.dataTable) {
            if (this.dataTable.total() > 1) {
                chart.valueAxis = [];
                _.forEach(this.dataTable.getAll(), (tb, tbNumber) => {
                    if (table.simple) {
                        return chart.valueAxis.push({
                            name: `${tbNumber}_${this.dataTable.getRows(1, tbNumber)[0]}`,
                            visible: false,
                            majorGridLines: {
                                visible: false
                            }
                        });
                    } else {
                        return chart.valueAxis.push({
                            name: `${tbNumber}_${this.dataTable.getRows(1, tbNumber)[0]}`,
                            color: this._getLabelColor(0, table.colors[tbNumber])
                        });
                    }
                });
            } else if (table.simple) {
                chart.valueAxis = {
                    name: `0_${this.dataTable.getRows(1)[0]}`,
                    visible: false,
                    majorGridLines: {
                        visible: false
                    }
                };
            } else {
                chart.valueAxis = {
                    name: `0_${this.dataTable.getRows(1)[0]}`,
                    majorGridLines: {
                        visible: false
                    }
                };
            }

            chart.valueAxis.labels = {
                visible: _.isBoolean(table.label) ? table.label : true,
                font: '12px "Roboto Condensed", Helvetica, Arial, sans-serif'
            };

            if (table.percent) {
                chart.tooltip.format = '{0:p2}';
            }

            if (table.type === 'pie') {
                chart.seriesDefaults = {
                    labels: {
                        position: 'center',
                        visible: true,
                        background: 'transparent',
                        format: table.percent ? '{0:p2}' : '{0}',
                        font: `bold 9px 'Roboto Condensed', sans-serif`,
                        color: '#FFF'
                    }
                };
            } else {
                let value = "points[i].value";

                if (table.currency) {
                    value = `#: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', }).format(points[i].value) #`;
                } else if (table.percent) {
                    value = `#: (Math.round(${value} * 1000) / 10) #%`;
                } else {
                    value = `#: ${value} #`;
                }

                chart.tooltip.template = kendo.template(`
                    <div style="clear:both;">
                        <div style="float: left;color:#: series.color#;">#: series.name#: </div>
                        <div class="fg-grey darken-1" style="padding-left: 4px;float: right;font-weight: bold;">#: value #</div>
                    </div>
                `);
                chart.tooltip.sharedTemplate = kendo.template(`
                    # for (var i = 0; i < points.length; i++) { #
                    <div style="clear:both;">
                        <div style="float: left;color:#: points[i].series.color#;">#: points[i].series.name#: </div>
                        <div class="fg-grey darken-1" style="padding-left: 4px;float: right;font-weight: bold;"> ${value} </div>
                    </div>
                    # } #
                `);
            }

            chart.tooltip = _.assign({}, chart.tooltip, table.tooltip);
            const categories = this.dataTable.getHeader('all');
            categories.shift();
            chart.categoryAxis = {
                categories,
                labels: {
                    font: `bold 11px 'Roboto Condensed', Helvetica, Arial, sans-serif`,
                    color: '#555555',
                    format: table.format ? table.format : '{0}'
                },
                crosshair: {
                    visible: !table.simple,
                    template: '<span style="color:#: series.color#">#: series.name#</span>: <b>#: value#</b><br/>',
                    format: table.format ? table.format : '{0}'
                },
                majorGridLines: {
                    visible: !table.simple
                }
            };

            // get the data of the chart
            chart.series = [];
            const limit = this.wrapper.isFullscreen ? 40 : table.limit ? table.limit : 0;

            if (table.type === 'pie') {
                const lastTable = this.dataTable.total() - 1;
                const series = {};

                const data = [];

                _.forEach(this.dataTable.getRows(0, lastTable, limit), (row, i) => {
                    const color = this._getChartColor(i, table.colors);
                    return data.push({
                        category: row[0],
                        value: table.percent ? Math.round((row[1] / this.dataTable.get(0).total) * 10000) / 10000 : row[1],
                        color
                    });
                });

                series.data = data;
                series.colorField = 'color';
                series.name = this.dataTable.getHeader(lastTable)[0];
                series.type = table.type;

                if (table.stacking) {
                    series.stack = { type: table.stacking };
                }

                series.labels = {
                    visible: true,
                    font: `bold ${this.wrapper.isFullscreen ? '15' : '11'}px 'Roboto Condensed', Helvetica, Arial, sans-serif`,
                };

                if (table.format) {
                    series.labels.format = table.format;
                    series.tooltip = { format: table.format };
                    series.labels.color = (data) => tinycolor(data.dataItem.color).getBrightness() < 160 ? '#FFF' : '#555555';
                }

                chart.series.push(series);
            }

            if (table.type !== 'pie') {
                _.forEach(this.dataTable.getAll(), (tb, tbNumber) => {
                    _.forEach(this.dataTable.getRows(0, tbNumber, limit), (row, i) => {
                        let skip = false;

                        if (table.skip) {
                            skip = _.some(table.skip, n => row[0] === n);
                        }

                        if (skip) {
                            return;
                        }

                        const series = {};
                        series.data = [];
                        series.name = row[0];
                        series.axis = `${tbNumber}_${this.dataTable.getRows(1, tbNumber)[0]}`;
                        series.type = _.isArray(table.type) ? table.type[tbNumber] : table.type;

                        series.markers = {
                            visible: true,
                            background: this.dataTable.total() > 1
                                ? this._getChartColor(i, table.colors[tbNumber])
                                : this._getChartColor(i, table.colors)
                        };

                        series.color =
                            this.dataTable.total() > 1
                                ? this._getChartColor(i, table.colors[tbNumber])
                                : this._getChartColor(i, table.colors);

                        if (table.data._tables[0].data[i].DncIdLocale) {
                            series.dncIdLocale = table.data._tables[0].data[i].DncIdLocale;
                        }

                        if (table.gap >= 0) {
                            series.gap = table.gap;
                        }

                        if (table.spacing >= 0) {
                            series.spacing = table.spacing;
                        }

                        if (table.opacity) {
                            series.opacity = table.opacity;
                        }

                        if (table.format) {
                            series.tooltip = { format: table.format };
                        }

                        if (table.stacking) {
                            series.stack = { type: table.stacking };
                        }

                        if (_.isBoolean(table.label) && table.label) {
                            series.labels = {
                                position: 'outsideEnd',
                                visible: true,
                                font: `bold 11px 'Roboto Condensed', Helvetica, Arial, sans-serif`,
                                color: '#555555',
                                format: table.format ? table.format : '{0}'
                            };
                            if (table.stacking) {
                                series.labels = false;
                                if (table.skip ? this.dataTable.getTotalRows(tbNumber) - 1 - table.skip.length : this.dataTable.getTotalRows(tbNumber) - 1) {
                                    chart.categoryAxis.labels.font = `bold 11px 'Roboto Condensed', Helvetica, Arial, sans-serif`;
                                    chart.categoryAxis.labels.color = '#555555';
                                    if (table.format) {
                                        chart.categoryAxis.labels.format = table.format;
                                    }
                                    const _header = this.dataTable.getHeader(tbNumber);
                                    const _rows = this.dataTable.getRows(0, tbNumber);
                                    chart.categoryAxis.labels.template = value => {
                                        const category = value.value;
                                        let values = '';
                                        let column = 1;
                                        _.forEach(_header, function (n, col) {
                                            if (n === category) {
                                                column = col;
                                            }
                                        });
                                        _.forEach(_rows, (r, j) => {
                                            if (!r[column]) {
                                                return;
                                            }
                                            skip = false;
                                            if (table.skip) {
                                                skip = _.some(table.skip, n => r[0] === n);
                                            }
                                            if (skip) {
                                                return;
                                            }
                                            values += kendo.toString(r[column], 'n2');
                                            if (j < (table.skip ? this.dataTable.getTotalRows() - 1 - table.skip.length : this.dataTable.getTotalRows() - 1)) {
                                                values += '\n';
                                            }
                                        });
                                        kendo.template('#:category#\n #:values#')({ category, values });
                                    };
                                }
                            }
                        }

                        _.forEach(_.range(1, row.length), j => {
                            let value = row[j];
                            if (table.percent && _.isNumber(value)) {
                                value = Math.round((value / this.dataTable.get(tbNumber).total) * 10000) / 10000;
                            }
                            return series.data.push(value);
                        });

                        chart.series.push(series);
                    });
                });
            }
        }
        return chart;
    }
}

export default KendoChart;



// WEBPACK FOOTER //
// ./src/scripts/core/charts/KendoChart.js